import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import YourTrustedVAAndNCTaxPartners from "./sections/YourTrustedVAAndNCTaxPartners";
import PourquoiChoisirAfricaGold from "./sections/PourquoiChoisirAfricaGold";
import OurExpertise from "./sections/OurExpertise";
import ImpactStories from "./sections/ImpactStories";
import ClientTestimonials from "./sections/ClientTestimonials";
import DesignThinkingInsights from "./sections/DesignThinkingInsights";
import SecureCollaboration from "./sections/SecureCollaboration";
import RodapeItc from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <YourTrustedVAAndNCTaxPartners />
      <PourquoiChoisirAfricaGold />
      <OurExpertise />
      <ImpactStories />
      <ClientTestimonials />
      <DesignThinkingInsights />
      <SecureCollaboration />
      <RodapeItc />
    </div>;
}